import React, { useMemo } from "react";
import { RotateCcw } from "lucide-react";
import "./ProgressHeader.css";

interface ProgressHeaderProps {
  checkedCount: number;
  totalItems: number;
  onReset: () => void;
}

const ProgressHeader: React.FC<ProgressHeaderProps> = ({
  checkedCount,
  totalItems,
  onReset,
}) => {
  const percent = useMemo(
    () => (totalItems === 0 ? 0 : Math.round((checkedCount / totalItems) * 100)),
    [checkedCount, totalItems],
  );

  return (
    <div className="progress-header">
      <div className="progress-header__top">
        <div>
          <p className="progress-header__eyebrow">MyRep QA</p>
          <p className="progress-header__title">Pre-Deploy Checklist</p>
        </div>
        <div className="progress-header__right">
          <span className="progress-header__count">
            {checkedCount} / {totalItems}
          </span>
          <button
            className="progress-header__reset"
            type="button"
            onClick={onReset}
          >
            <RotateCcw size={14} />
            Reset
          </button>
        </div>
      </div>
      <div className="progress-header__bar">
        <div
          className="progress-header__bar-fill"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressHeader;
